var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"plk_documentation",domProps:{"innerHTML":_vm._s(_vm.readmeList[_vm.type])}})])
}
var staticRenderFns = []

export { render, staticRenderFns }